import { render, staticRenderFns } from "./EditConfig.vue?vue&type=template&id=16cbb2cd&scoped=true"
import script from "./EditConfig.vue?vue&type=script&lang=js"
export * from "./EditConfig.vue?vue&type=script&lang=js"
import style0 from "./EditConfig.vue?vue&type=style&index=0&id=16cbb2cd&prod&scoped=true&lang=less"
import style1 from "./EditConfig.vue?vue&type=style&index=1&id=16cbb2cd&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16cbb2cd",
  null
  
)

export default component.exports